<template>
  <!-- style="width: 100%;height: 100%;" -->
  <el-form label-position="left" :model="formInline" :style="{ width: ifShow100 ? '80%' : '100%', height: '100%' }"
    ref="formInline" class="demo-ruleForm login-container">
    <h3 class="title">用户注册</h3>
    <el-form-item prop="username">
      <el-input placeholder="请输入手机号" type="number" v-model="formInline.username" />
      <!-- </el-input> -->
    </el-form-item>
    <el-form-item prop="password">
      <el-input placeholder="请输入密码" v-model="formInline.password" show-password></el-input>
    </el-form-item>
    <div style="width: 100%;height: 40px;">
      <el-button type="primary" style="width:100%;" @click="userRegister('formInline')">注册</el-button>
    </div>
  </el-form>
</template>
<script type="text/ecmascript-6">
import { login } from '../api/userMG'
import { register } from '../api/userMG'
import { setCookie, getCookie, delCookie } from '../utils/util'
import md5 from 'js-md5'
export default {
  name: 'login',
  props: {
    ifShow100: Boolean
  },
  data() {
    return {
      formInline: {}
    }
  },
  // 创建完毕状态(里面是操作)
  created() {

  },
  // 里面的函数只有调用才会执行
  methods: {
    // 判断是否是手机端，如果是，返回true
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    userRegister(params) {
      let formInline = this.formInline;
      if (formInline.username != null && formInline.username != ''
        && formInline.password != null && formInline.password != '') {
        let referenceId = this.$route.query.referenceId;
        if (referenceId != null) {
          formInline.referenceId = referenceId;
        } else {
          formInline.referenceId = null;
        }
        register(formInline).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '注册成功！',
              type: 'success'
            });
            if (this._isMobile()) {
              this.$confirm('当前为手机端是否跳转网页端首页登录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$router.replace('/login')
              }).catch(() => {

              });
            } else {
              this.$router.replace('/login')
            }
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        this.$message.error('请输入手机号与密码！')
        return false
      }

    }
  }
}
</script>

<style scoped>
.login-container {
  /* border-radius: 10px; */
  width: 100%;
  padding: 0px 35px 15px 35px;
  background: #fff;
  /* border: 1px solid #eaeaea; */
  text-align: left;
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.remember {
  margin: 0px 0px 35px 0px;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}

/deep/ .el-input__inner::-webkit-outer-spin-button,
/deep/ .el-input__inner::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/deep/ .el-input__inner[type='number'] {
  -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// src/views/register.vue